import { RootState } from "@/app/stores";
import { getAircraft, IAircraft, getAirlines, IAirline, getAirports, IAirport, getCountries, ICountry } from "@/shared/api/aviabooking";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

export const fetchCountries = createAsyncThunk<
    ICountry[],
    void,
    { state: RootState }
>('aviabooking/fetchCountries', async(_, thunkAPI) => {
    try {
        const response = await getCountries({
            language: "ru",
            countryCode: ""
        })
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchAirlines = createAsyncThunk<
    IAirline[],
    void,
    { state: RootState }
>('aviabooking/fetchAirlines', async(_, thunkAPI) => {
    try {
        const response = await getAirlines({
            language: "ru",
            code: "",
        })
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchAircraft = createAsyncThunk<
    IAircraft[],
    void,
    { state: RootState }
>('aviabooking/fetchAircraft', async(_, thunkAPI) => {
    try {
        const response = await getAircraft({
            language: "ru",
            code: "",
        })
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchAirports = createAsyncThunk<
    IAirport[],
    void,
    { state: RootState }
>('aviabooking/fetchAirports', async(_, thunkAPI) => {
    try {
        const response = await getAirports({
            language: "ru",
            code: "",
            countryCode: ""
        })
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})